import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '../../_services/encryption';
const state = {
    getUserSaveAsYouSpend: [],
    getUserSaveAsYouSpendHistory: [],
    balanceEnquiry: '',
};
const mutations = {
    // set save as you spend
    SET_SAVE_AS_YOU_SPEND(state, payload) {
        state.getUserSaveAsYouSpend = payload;
    },
    // set save as you spend history
    SET_SAVE_AS_YOU_SPEND_HISTORY(state, payload) {
        state.getUserSaveAsYouSpendHistory = payload;
    },
    // set balance enquiry
    SET_BALANCE_ENQUIRY(state, payload) {
        state.balanceEnquiry = payload;
    }
};
const actions = {
    // get save as you spend
    async getSaveAsYouSpend({ commit }, payload) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/SaveAsYouSpend?accountNumber=${payload}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_SAVE_AS_YOU_SPEND', userParseData);
            }
            return response;
        }
    },
    // create save as you spend
    async createSaveAsYouSpend({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/SaveAsYouSpend/Update`, encryptedData, { headers });
            return response;
        }
    },
    // fetch save as you spend history
    async getSaveAsYouSpendHistory({ commit }, { data }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/SaveAsYouSpend/History/${data.accountNumber}/${data.period}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_SAVE_AS_YOU_SPEND_HISTORY', userParseData);
            }
            return response;
        }
    },
    // delete save as you spend
    async deleteSaveAsYouSpend({ }, payload) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.put(`/SaveAsYouSpend/delete/${payload}`, payload, { headers });
            return response;
        }
    },
    // delete save as you spend type
    async deleteSaveAsYouSpendType({ }, { payload }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.put(`/SaveAsYouSpend/delete/${payload.accountNumber}/${payload.period}`, payload, { headers });
            return response;
        }
    },
    // withdraw save as you spend
    async withdrawFromWallet({ }, payload) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Wallet/walletToAccountTransfer`, payload, { headers });
            return response;
        }
    },
    // balance enquiry
    async getBalanceEnquiry({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Wallet/balanceEnquiry`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_BALANCE_ENQUIRY', userParseData);
            }
            return response;
        }
    }
};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};